import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.CRITICAL_INCIDENTS_GLOBAL_LIST}`,
            render: () => import("../../Pages/CaseManagement/CriticalIncidents/List/CriticalIncidentsList.svelte"),
            title: "Critical Incidents"
        }
    ]
};

export default routerConfig;

